import clsx from 'clsx';
import { useAllFeatureFlags } from 'context/FeatureFlagContext';
import { NavLink } from 'react-router-dom';

import { isNavEntryEnabled, SIDE_NAV_CONFIG } from './SideNav.config';

export const SideNav: React.FC<{ className?: string }> = ({ className }) => {
  const flags = useAllFeatureFlags();
  return (
    <div className={clsx('ml-3 mt-24 inline-flex flex-col gap-3 p-2', className)}>
      {SIDE_NAV_CONFIG.map((navConfig) => {
        const disabled = !isNavEntryEnabled(navConfig, flags);
        return (
          <li className="list-none text-center" key={navConfig.routeSegment}>
            <NavLink
              to={`${navConfig.routeSegment}`}
              data-tour={
                navConfig.routeSegment === 'home' ? 'loan-level-data-side-nav-home' : undefined
              }
              className={({ isActive }) =>
                clsx(
                  'flex flex-col items-center p-1 px-2 pt-3 text-[8px] text-white no-underline',
                  {
                    'pointer-events-none cursor-not-allowed opacity-20': disabled,
                    'rounded border border-accent-emphasis bg-gray-950': isActive,
                  },
                )
              }
              tabIndex={disabled ? -1 : 0}
            >
              <navConfig.icon />
              <div className="mt-2 leading-snug">{navConfig.text}</div>
            </NavLink>
          </li>
        );
      })}
    </div>
  );
};
